import React from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import '../../sass/components/flexibleModules/_components.fullWidthTestimonialModuleComponent.scss';

const FullWidthTestimonialModuleComponent = ({ data }) => {
    return (
        <div className="cp-fullWidthTestimonialModuleComponent" style={{ backgroundColor: `${data.backgroundColor}` }}>
            <div className="cp-fullWidthTestimonialModuleComponent__inner" style={{ maxWidth: `${data.maxWidth ? (data.maxWidth/16+"rem") : ""}`, margin: "0 auto" }}>
                {data.fullWidthTestimonialModuleLogo &&
                    <GatsbyImage image={data.fullWidthTestimonialModuleLogo.gatsbyImage} alt={data.fullWidthTestimonialModuleLogo.altText} />
                }
                {data.fullWidthTestimonialModuleTestimonial &&
                    <h2>{data.fullWidthTestimonialModuleTestimonial}</h2>
                }
                {data.fullWidthTestimonialModuleAuthorThumb &&
                    <GatsbyImage image={data.fullWidthTestimonialModuleAuthorThumb.gatsbyImage} alt={data.fullWidthTestimonialModuleAuthorThumb.altText} />
                }
                {data.fullWidthTestimonialModuleAuthorName &&
                    <h5 className="cp-fullWidthTestimonialModuleComponent__authorName">{data.fullWidthTestimonialModuleAuthorName}</h5>
                }
                {data.fullWidthTestimonialModuleAuthorTitle &&
                    <p className="cp-fullWidthTestimonialModuleComponent__authorTitle">{data.fullWidthTestimonialModuleAuthorTitle}</p>
                }                
            </div>
        </div>
    );
}

export default FullWidthTestimonialModuleComponent;